<template>
<div class="col-md-12 mr-auto ml-auto">
  <breadcrumb :items="[{ text: 'Editar página de conteúdo', active: true }]" />
  <b-form @submit.prevent="save" v-if="!isLoading">
    <b-form-group>
      <b-form-group label="Titulo" description="Aparecerá no meio do banner">
        <b-form-input v-model="form.title" type="text" placeholder="Título" />
      </b-form-group>
      <b-form-group label="Subtitulo" description="Frase logo abaixo do titulo, no banner">
        <form-editor :form="form" field="subtitle" />
      </b-form-group>
      <pictures-upload :form="form" field="image" url="uploads/images" required :multiple="false" label="Foto do Banner" />
      <b-form-group label="Resumo" description="Breve resumo do conteúdo">
        <form-editor :form="form" field="outline" />
      </b-form-group>
      <b-form-group label="Conteúdo">
        <form-editor :form="form" field="content" />
      </b-form-group>
      <div class="card-footer">
        <form-submit :errors="error" :sending="isSending" label="Salvar" />
      </div>
    </b-form-group>
  </b-form>
</div>
</template>

<script>
import FormEditor from "@/components/FormEditor";
import PicturesUpload from "@/components/PicturesUpload";
import FormSubmit from "@/components/FormSubmit";
import axios from "axios";

export default {
  name: "ContentForm",
  data() {
    return {
      slug: this.$route.params.slug,
      form: {
        title: "",
        subtitle: "",
        outline: "",
        content: "",
        image: {}
      }
    };
  },
  created() {
    this.edit();
  },

  methods: {
    edit() {
      this.isLoading = true;
      axios
        .get("content/" + this.slug, {})
        .then(response => {
          this.apiDataToForm(this.form, response.data);
          this.isLoading = false;
        })
        .catch(this.showError);
    },
    save() {
      this.$validator.validate().then(isValid => {
        if (isValid) {
          this.isSending = true;
          this.error = false;
          axios({
              method: "PUT",
              url: "content/" + this.slug,
              data: this.form
            })
            .then(resp => {
              var product = resp.data;
              if (product && product._id) {
                this.notify("A página foi salva!");
                if (this.isEditing()) {
                  window.scrollTo(0, 0);
                  this.tab += 1;
                } else {
                  window.scrollTo(0, 0);
                  // redirect to page?
                  this.$router.replace("/conteudo/" + this.slug);
                }
              }
              this.isSending = false;
            })
            .catch(this.showError);
        }
      });
    }
  },
  watch: {
    $route(to) {
      this.slug = to.params.slug;
      this.edit();
      this.$nextTick(() => {
        this.form = {
          title: "",
          subtitle: "",
          outline: "",
          content: "",
          image: {}
        };
      });
    }
  },
  components: {
    FormEditor,
    PicturesUpload,
    FormSubmit
  }
};
</script>
